/**
 * @module app.shared
 */

export const signalNames = Object.freeze({
    timeZoneChanged: 'timezone-changed-signal',
    languageChanged: 'aurelia-translation-signal',
    clockTickMinute: 'minute-tick-signal',
    clockTickSecond: 'second-tick-signal'
});
